import { render, staticRenderFns } from "./copyProject.vue?vue&type=template&id=cd1ec82c&scoped=true&"
import script from "./copyProject.vue?vue&type=script&lang=js&"
export * from "./copyProject.vue?vue&type=script&lang=js&"
import style0 from "./copyProject.vue?vue&type=style&index=0&id=cd1ec82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1ec82c",
  null
  
)

export default component.exports